/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
  LineChart,
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  Line,
  XAxis,
  YAxis,
} from 'recharts'
import { connect } from 'react-redux'
import UIkit from 'uikit'
import moment from 'moment'
import Icon from 'app/views/components/Icon'
import {
  getLMSIntegrations,
  rerunSyncLMSIntegration,
  deleteLMSIntegration,
  getLMSIntegrationDetail,
} from 'app/state/modules/integrations'
import settings from 'settings'

import OrganizationLayout from '../components/Layout'
import getLocalDateFromUTC from 'app/views/utils/getLocalDateFromUTC'

class LMSIntegrationsDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      syncing: false,
      syncStatus: {
        syncing: false,
        last_sync_at: null,
      },
    }
    this.onDelete = this.onDelete.bind(this)
    this.initInterval = this.initInterval.bind(this)
    this.keys = {
      exceed: 1,
    }
  }

  componentDidMount() {
    this.props.getLMSIntegrations(this.props.match.params.organization_uuid)
    this.props.getLMSIntegrationDetail(
      this.props.match.params.organization_uuid,
      this.keys[this.props.match.params.integration],
      true,
      (data) => this.setState({
        syncStatus: {
          ...this.state.syncStatus,
          syncing: data.sync_status.syncing,
          last_sync_at: data.sync_status.last_sync_at,
        },
      }, () => {
        if (this.state.syncStatus.syncing) {
          this.initInterval()
        }
      }),
    )
  }

  onDelete(typeId) {
    UIkit.modal.confirm('Are you sure you want to remove this integration? New progress information will not be send to your LMS', {
      stack: true,
    })
      .then(() => {
        this.props.deleteLMSIntegration(
          this.props.match.params.organization_uuid,
          typeId,
          () => {
            window.location.assign(`/admin/${this.props.match.params.organization_uuid}/lms-integrations`)
          },
        )
      }, () => {
      })
  }

  initInterval() {
    this.interval = setInterval(() => {
      this.props.getLMSIntegrationDetail(
        this.props.match.params.organization_uuid,
        this.keys[this.props.match.params.integration],
        true,
        (data2) => this.setState({
          syncing: data2.sync_status.syncing,
          syncStatus: {
            ...this.state.syncStatus,
            syncing: data2.sync_status.syncing,
            last_sync_at: data2.sync_status.last_sync_at,
          },
        }, () => {
          if (!this.state.syncStatus.syncing) {
            if (this.interval) {
              clearInterval(this.interval)
            }
          }
        }),
      )
    }, 5000)
  }

  render() {
    if (this.props.lmsIntegrationsLoading) {
      return null
    }
    const integration = this.props.lmsIntegrations.find((item) => (
      item.type_key === this.props.match.params.integration && item.organization_uuid
    ))
    if (!integration) {
      return (
        <OrganizationLayout
          active="lms_integrations"
          isLoading={this.props.loadingIntegrations}
          {...this.props}
        >
          <div className="uk-text-center uk-padding-large uk-flex uk-flex-center uk-flex-column uk-flex-middle">
            <p>You don't have this integration registered</p>
            <button
              onClick={() => {
                this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/lms-integrations/add`)
              }}
              className="uk-button uk-button-secondary uk-flex uk-flex-middle"
              type="button"
            >
              <Icon
                className="uk-margin-right"
                name="arrow-left"
              />
              Go Back
            </button>
          </div>
        </OrganizationLayout>
      )
    }
    return (
      <OrganizationLayout
        active="lms_integrations"
        isLoading={this.props.loadingIntegrations}
        {...this.props}
      >

        <h1
          className="uk-flex uk-flex-between"
        >
          {settings.integrationsLms[integration.type_key]}
          <div className="uk-flex uk-flex-row uk-flex-middle uk-flex-center">
            <button
              disabled={integration.syncing || this.state.syncing}
              className="uk-button uk-button-primary uk-flex-middle uk-flex uk-margin-right uk-button-small"
              type="button"
              onClick={() => {
                this.setState({
                  syncing: true,
                }, () => {
                  this.props.rerunSyncLMSIntegration(
                    this.props.match.params.organization_uuid,
                    integration.type_id,
                  )
                  this.initInterval()
                })
              }}
            >
              <Icon
                name="refresh"
                className="uk-margin-right"
              />
              {integration.syncing || this.state.syncing ? 'Syncing...' : 'Re-Run Sync'}
            </button>
            <button
              type="button"
              onClick={() => this.onDelete(integration.type_id)}
              className="uk-button uk-button-default uk-button-small uk-flex uk-flex-middle"
            >
              <Icon
                name="delete-bin"
                ratio={0.8}
                className="uk-margin-small-right"
              />
                Delete Integration
            </button>
          </div>
        </h1>

        <h5>
          {integration.type_settings.fields.domain.name}
          :
        </h5>
        <div className="uk-placeholder uk-text-muted uk-padding-small uk-flex uk-position-relative" style={{ paddingLeft: 60 }}>
          <Icon
            className="uk-text-muted"
            name="links"
            style={{
              position: 'absolute',
              left: 20,
            }}
          />
          {integration.settings.domain}
        </div>
        <h5>
          {integration.type_settings.fields.username.name}
          :
        </h5>
        <div className="uk-placeholder uk-text-muted uk-padding-small uk-flex uk-position-relative" style={{ paddingLeft: 60 }}>
          <Icon
            className="uk-text-muted"
            name="user"
            style={{
              position: 'absolute',
              left: 20,
            }}
          />
          {integration.settings.username}
        </div>
        <h5>
          {integration.type_settings.fields.secret.name}
          :
        </h5>
        <div className="uk-placeholder uk-text-muted uk-padding-small uk-flex uk-position-relative" style={{ paddingLeft: 60 }}>
          <Icon
            className="uk-text-muted"
            name="key-2"
            style={{
              position: 'absolute',
              left: 20,
            }}
          />
          {integration.settings.secret}
        </div>
        <div className={`uk-alert-${(this.state.syncStatus.last_sync_at ? 'success' : 'primary')} uk-alert uk-margin-top`}>
          <p>
            This integration is automatically synced every time a user completes
            a lesson.
          </p>
          <p>
            <i>Last synced:</i>
            &nbsp;
            <span className="uk-text-bold">
              {this.state.syncStatus.last_sync_at ? getLocalDateFromUTC(this.state.syncStatus.last_sync_at).fromNow() : 'Never'}
            </span>
          </p>
        </div>
        <h2>User Content Synced</h2>
        {this.props.lmsIntegrationChart.length === 0 && (
          <p>No data synced yet...</p>
        )}
        {this.props.lmsIntegrationChart.length > 0 && (
          <ResponsiveContainer id="teams-chart" height={350} className="uk-text-small uk-width-1-1">
            <AreaChart
              data={this.props.lmsIntegrationChart}
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 0,
              }}
            >
              <XAxis
                dataKey="synced_date"
                tickFormatter={(date) => {
                  if (date === '') {
                    return ''
                  }
                  return `  ${moment(date).format('MMM D, hh a')}`
                }}
              />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Area type="monotone" dataKey="total" name="Lessons Sync" fill="#1e87f0" />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = ({ hacker, integrations }) => ({
  organizations: hacker.organizationsList,
  organizationsHash: hacker.organizationsHash,
  lmsIntegrations: integrations.lmsIntegrations,
  lmsIntegrationsLoading: integrations.lmsIntegrationsLoading,
  lmsIntegrationChart: integrations.lmsIntegrationChart,
})

export default connect(mapStateToProps, {
  getLMSIntegrations,
  deleteLMSIntegration,
  rerunSyncLMSIntegration,
  getLMSIntegrationDetail,
})(LMSIntegrationsDetail)
